import { ReactNode, useEffect, useState } from 'react';
import { PersistGate } from 'redux-persist/integration/react';
import { persistor } from '../../redux/configureStore';

type Props = {
  children: ReactNode;
};

export function PersistGateContainer({ children }: Props) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  const [isAuth, setIsAuth] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('access_token')) {
      setIsAuth(true);
    } else {
      setIsAuth(false);
    }
  }, []);

  return isAuth ? (
    <PersistGate loading={null} persistor={persistor}>
      {children}
    </PersistGate>
  ) : (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
}
